<script lang="ts" src="./FormSelectPickerWrapper.ts"></script>

<template>
  <div class="m-input-group">
    <m-form-label
      v-if="label"
      :id="id"
      :required="required"
      :tooltipLabel="tooltipLabel"
      :tooltipLink="tooltipLink"
    >
      {{ label }}
    </m-form-label>

    <m-form-select-picker
      :id="id"
      :allLabel="allLabel"
      :direction="dropdownDirection"
      :disabled="disabled"
      :dropdownMaxCols="dropdownMaxCols"
      :dusk="dusk"
      :errors="errors"
      :items="items"
      :maxVisibleStep="maxVisibleStep"
      :modelValue="modelValue"
      :multiselect="multiselect"
      :omitItemIcons="!showDropdownIcons"
      :placeholder="placeholder"
      :prependIcon="iconBefore"
      :required="required"
      :size="size"
      @update:modelValue="updateValue"
    />

    <p v-if="supportText" class="support-text">
      {{ supportText }}
    </p>
  </div>
</template>


<style lang="scss" scoped>
</style>
